<div class="wrapper">
  <p class="templates">
    <ng-container *ngIf="isHasTemplates; else templateNotSelected">
      <mat-icon>check</mat-icon>
      {{ "teams.LocatePackage.TemplatesSelected" | translate }}
    </ng-container>

    <ng-template #templateNotSelected>
      {{ "teams.LocatePackage.NoTemplates" | translate }}
    </ng-template>
  </p>

  <button mat-raised-button color="primary" class="add-pdf-button" (click)="openLoadPdfDialog()">
    {{ "teams.LocatePackage.LoadPdf" | translate }}
  </button>
</div>
